import React from 'react';

import { type LanguageItemsProps } from '../LanguageSelector.types';

import { LanguageItem } from './LanguageItem';

/**
 * List of language items component
 * Renders all available language options
 *
 * @param props - Language items list properties
 * @returns JSX element containing all language options
 */
export const LanguageItems: React.FC<LanguageItemsProps> = ({
  languageData,
  onSelectLanguage,
}) => {
  return (
    <ul className="space-y-1">
      {languageData.map(({ language, icon, label }) => (
        <LanguageItem
          key={language}
          langKey={language}
          icon={icon}
          label={label}
          onSelectLanguage={onSelectLanguage}
        />
      ))}
    </ul>
  );
};
